import React from "react"

import {
  Container,
  Row,
  Col,
  Badge,
  Button,
  Collapse
} from "react-bootstrap"

import { openstreetmapService, vendorService, catalogService } from '../../services';
import CardVendor from "../../components/CardVendor"
import CompanyOverview from "../../components/Company/CompanyOverview"
import CompanyFocus from "../../components/Company/CompanyFocus"
import CompanyLocation from "../../components/Company/CompanyLocation"
import CompanyPortfolio from "../../components/Company/CompanyPortfolio"

// import Reviews from "../../components/Reviews"
// import ReviewForm from "../../components/ReviewForm"

//
const groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

//
const groupValues = (values) => {
  const entries = new Map();
  for (let key in values) {
    let obj = groupBy(values[key], 'groupvalue')
    entries.set(key, obj);
  }
  return Object.fromEntries(entries);
}

//
const routerItem = (arr, code) => {
  const res = arr.filter((f) => f.group_code === code)
    .map((item) => (
      {
        id: item.category_map_id,
        group_code: item.group_code,
        parent_code: item.parent_code,
        code: item.code,
        url: item.url
      }))
  return res || []
}

export async function getServerSideProps({ params, req, res }) {
  const { slug = '' } = await params;
  //const { user } = getSession(req, res);
  const data = await vendorService.getProfileByName(slug);

  if (!data || data.length == 0) {
    return {
      notFound: true,
    }
  }

  const categoryMap = await catalogService.getCategoriesRouter();
  await openstreetmapService.setMapFeatures(data[0]?.locations || [])

  const { industries, categories, subcategories, platforms, subsystems } = data[0];

  const categoryRouter = {
    categories: routerItem(categoryMap, 'category'),
    subcategories: routerItem(categoryMap, 'subcategory'),
    // subsystems: subsystems || [],
    platforms: routerItem(categoryMap, 'platform'),
    industries: routerItem(categoryMap, 'industry'),
  }

  const initValues = {
    industries: industries || [],
    categories: categories || [],
    subcategories: subcategories || [],
    subsystems: subsystems || [],
    platforms: platforms || []
  };

  const focus = groupValues(initValues);
  const meta = data[0].company.company_description.split('.', 2)[0] || ""

  focus.categories?.['CAT'].forEach((item) => {
    item.url = categoryRouter.categories.find((f) => f.code === item.value)?.url || ""
  })

  focus.industries?.['IND'].forEach((item) => {
    item.url = categoryRouter.industries.find((f) => f.code === item.value)?.url || ""
  })

  Object.keys(focus.subcategories).forEach((name) => {
    return focus.subcategories[name].forEach((item) => {
      item.url = categoryRouter.subcategories.find((f) => f.code === item.value)?.url || ""
    })
  })

  Object.keys(focus.platforms).forEach((name) => {
    return focus.platforms[name].forEach((item) => {
      item.url = categoryRouter.platforms.find((f) => f.code === item.value)?.url || ""
    })
  })

  return {
    props: {
      nav: {
        light: true,
        classes: "shadow",
        color: "white",
      },
      title: `${data[0].title} - Vendorland Company Profile`,
      meta: meta,
      data: data[0],
      focus: focus
    },
  }
}

const sidebarMenu = [
  {
    label: "Overview",
    to: "overview",
    enable: true
  },
  {
    label: "Speciality",
    to: "speciality",
    enable: true
  },
  {
    label: "Location",
    to: "location",
    enable: true
  },
  {
    label: "Portfolio",
    to: "portfolio",
    enable: true
  }
]

//--
export const CompanyProfile = (props) => {
  const [activeTab, setActiveTab] = React.useState(0)
  const [personalCollapse, setPersonalCollapse] = React.useState(false)

  const toggle = (tab) => {
    activeTab !== tab && setActiveTab(tab)
  }

  const {
    code, company,
    last_update,
    contact,
    portfolios
  } = props.data;

  const updated_date = new Date(last_update).getFullYear();
  sidebarMenu.find((f) => f.to === "portfolio").enable = ((portfolios || []).length > 0)

  return (
    <section className="py-5">
      <Container>
        <Row>
          <Col lg="9" className="ps-lg-5">
            <h1 className="hero-heading mb-0">{company.company_name}</h1>
            <div className="text-block-5 mb-3">
              <p>
                <Badge bg="secondary-light" text="secondary">Updated in {updated_date}</Badge>
              </p>
              {/* {company.company_description_ext && (

                  {company.company_description_ext.slice(0, 255)}
                  <Collapse in={personalCollapse}>
                    <div id="example-collapse-text">
                      {company.company_description_ext.slice(255)}
                    </div>
                  </Collapse>
                </div>
              )}
              {company.company_description_ext.slice(255) && (
                <>
                  <Button
                    //aria-expanded={personalCollapse}
                    variant="link"
                    className="ps-0 text-primary collapsed"
                    onClick={() => setPersonalCollapse(!personalCollapse)}
                  >{personalCollapse ? `Less text` : `Learn more`}
                  </Button>
                </>
              )} */}
              <p className="text-muted">{company.company_description}</p>
            </div>

            <CompanyOverview data={props.data} />
            <CompanyFocus data={props.focus} />
            <CompanyLocation data={props.data} />
            {(portfolios || []).length > 0 &&
              <CompanyPortfolio data={portfolios} />
            }
          </Col>
          <Col lg="3" className="me-lg-auto">
            <CardVendor sidebarMenu={sidebarMenu} data={props.data} />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default CompanyProfile